
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import { UserModule } from '../../store/modules/user'
import loges from '../../components/course/loges.vue'
import AddListPop from '../../components/course/add-list-pop.vue'
  @Component({
    components: { loges, AddListPop}
  })
export default class AddList extends Vue {
    @Prop() dialogAdd: boolean
    @Prop() modifyHeader: any
    @Prop() optionList: any
    @Prop() optionId: string
    @Prop() isAddType: string
    @Prop() itemValue: any
    @Prop() pageName: string
    @Prop() allData: any
    addOccupy: any = {}
    w_default: any = '50%'
    searchList: any = [] // 搜索 string
    selectList: any = [] // 筛选 dict
    keyList: any = [] // 筛选 key_value / foreign-key
    booleanList: any = [] // 筛选 boolean
    numberList: any = [] // 筛选 number
    timeList: any = [] // 筛选 time
    colorList: any = [] // 筛选 color
    addList: any = []
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    isEduOrderPage:boolean = false
    fileList: any = []
    upUrl: string = process.env.VUE_APP_IMG_API + 'api/core/upload-files/soco'
    editorOption: any = {
      modules: {
        toolbar: {
          container: [
            ['bold', 'italic', 'underline', 'strike'],        // 加粗，斜体，下划线，删除线
            ['blockquote', 'code-block'], // 引用，代码块
            [{ 'header': 1 }, { 'header': 2 }],               // 标题，键值对的形式；1、2表示字体大小
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 列表
            [{ 'script': 'sub' }, { 'script': 'super' }],      // 上下标
            [{ 'indent': '-1' }, { 'indent': '+1' }],          // 缩进
            [{ 'direction': 'rtl' }],                         // 文本方向
            [{ 'size': ['small', false, 'large', 'huge'] }],  // 字体大小
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 几级标题
            [{ 'color': [] }, { 'background': [] }],          // 字体颜色，字体背景颜色
            [{ 'font': [] }], // 字体
            [{ 'align': [] }],        // 对齐方式
            ['clean'],        // 清除字体样式
            ['link','image']        // 上传图片、上传视频
          ],
          handlers: {
            'image': function (value) {
                if (value) {
                    const dom: any = document.querySelector('.avatar-uploader input')
                    dom.click()
                } else {
                    this.quill.format('image', false);
                }
            }
          }
        }
      },
      theme: 'snow'
    }
    addCustomer_name: string = ''
    addCustomer_phone: string = ''
    essential: any = []
    props: any = { multiple: true }
    essentialOptions: any =  []
    logesFrom: string = ''
    actionBoolean: boolean = false
    orderId: string = ''
    is_show_log: boolean = false
    is_show_80: boolean = false

    // 商机管理 新建客户
    dialogAddPop: boolean = false
    modifyHeaderPop: any = []
    optionIdPop: string = ''
    optionListPop: any = []
    isAddTypePop: string = 'add'
    itemValuePop: any = []
    pageNamePop: string = ''
    allDataPop: any = {}
    logHeight: number = 800
    searchConditionInput: any = []
    is_customer_w_80: boolean = false
    is_customer_phone_add: boolean = false  // 判断新建客户弹窗走编辑接口还是新增接口
    is_customer_item: any = {}
    p_hight: any = window.innerHeight - 80 + 'px'
    quillUpdateImg: boolean = false // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
    serverUrl: string = process.env.VUE_APP_IMG_API + '/api/core/upload-files/soco'  // 这里写你要上传的图片服务器地址
    detailContent: string = '' // 富文本内容


    onEditorBlur() {} // 失去焦点事件
    onEditorFocus() {} // 获得焦点事件
    onEditorChange() {} // 内容改变事件

    // 上传图片前
    beforeUpload(res, file) {
      // 显示loading动画
      this.quillUpdateImg = true
    }
    // 上传图片成功
    uploadSuccess(res, file) {
      
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      const imageUrl = 'https://'+ res[0]
      let quill = this.$refs.text[0].quill
      // 获取光标所在位置
      let length = quill.getSelection().index;
      // 插入图片  res.info为服务器返回的图片地址
      quill.insertEmbed(length, 'image', imageUrl)
      // 调整光标到最后
      quill.setSelection(length + 1)
      // loading动画消失
      this.quillUpdateImg = false
    }
    // 上传图片失败
    uploadError(res, file) {
      // loading动画消失
      this.quillUpdateImg = false
      this.$message.error('图片插入失败')
    }

    async getCustomerPhoneInfo(val) {
      const res: any = await CourseModule.getCustomerPhoneInfo({phone: val})
      if(res.code === 200) {
        if(res.data.length > 0) {   // 适配新建客户联系方式筛选 注： 有数据为编辑 无数据是新建
          this.is_customer_phone_add = false
          this.is_customer_item = res.data[0]
          this.assignment(this.addList, this.is_customer_item)
        } else {
          this.is_customer_phone_add = true
        }
      }
    }
    changeCustomerPhone(val) {
      if(val.length === 11) {
        this.getCustomerPhoneInfo(val)
      }
    }

    changeSelect(val) {
      if (this.pageName === 'edu-order-page') {
        if (val.key === 'business_id') {
          this.isEduOrderPage = true
          this.getOtherData(val.model, '')
          this.getPacketData(val.model)
        } else if (val.key === 'customer_id') {
          this.isEduOrderPage = true
          this.getOtherData('', val.model)
        } else if (val.key === 'packet_id') {
          this.getPacket(val.model)
        }
      } else if (this.pageName === 'edu-business-page') {
        if (val.key === 'customer_id') {
          this.isEduOrderPage = true
          this.getCustomerInfo(val.model)
        }
      }
    }

    async essentialList() {
      let data = {
        is_enabled: 1 
      }
      const res: any = await CourseModule.essentialList(data)
      if (res.code === 200) {
        this.essential = res.data.list
        let data = []
        for(var i = 0; i < this.essential.length;i++) {
          let obj = {
            value: '',
            label: '',
            children: []
          }
          obj['value'] = this.essential[i].id
          obj['label'] = this.essential[i].name
          if(this.essential[i].two_data.length > 0) {
            for(var j = 0; j <  this.essential[i].two_data.length; j++) {
              let obj1 = {}
              obj1['value'] = this.essential[i].two_data[j].id
              obj1['label'] = this.essential[i].two_data[j].name
              obj.children.push(obj1)
            }
          } else {
            delete obj['children']
          }
          data.push(obj)
        }
        this.essentialOptions = data
      }
    }

    async getCustomerInfo(val) {
      const res: any = await CourseModule.customeInfo({ customer_id: val })
      this.assignment(this.addList, res.data[0])
      this.addCustomer_name = res.data[0].name
      this.addCustomer_phone = res.data[0].phone
    }
    changeDict(val) {
      if (this.pageName === 'edu-order-page') {
        if (val.key === 'order_type') {
          if (val.model === 1) { // 课程类
            this.orderChange(1)
          } else if (val.model === 2) { // 物品类
            this.orderChange(2)
          }
        }
      } else if (this.pageName === 'edu-business-page' && val.key === 'business_type') {
        if (Number(val.model) === 2) {  // 非试听
          this.getChange(false, 'teacher_id')
        } else if(Number(val.model) === 1) {  // 试听
          this.getChange(true, 'teacher_id')
        }
      }
    }
    

    async getPacket(id) {
      const res: any = await CourseModule.getPacket({ packet_id: id })
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].key === 'price') {
          this.addList[i].model = res.data[0].price
        }
      }
    }

    orderChange(type) {
      for (var i = 0; i < this.addList.length; i++) {
        if (type === 1) {
          if (this.addList[i].key === 'packet_id') {
            this.addList[i].show = true
          } else if (this.addList[i].key === 'other_name') {
            this.addList[i].show = false
            this.addList[i].mdoel = ''
          } else if (this.addList[i].key === 'price') {
            this.addList[i].model = ''
          }
        } else if (type === 2) {
          if (this.addList[i].key === 'packet_id') {
            this.addList[i].show = false
            this.addList[i].mdoel = ''
          } else if (this.addList[i].key === 'other_name') {
            this.addList[i].show = true
          } else if (this.addList[i].key === 'price') {
            this.addList[i].model = ''
          }
        }
      }
    }

    async getOtherData(id, customer_id) {
      const res: any = await CourseModule.getBusiness({ business_id: id, customer_id: customer_id })
      if (res.code === 200) {
        if (customer_id) {
          let businessList = []
          for (var i = 0; i < res.data.length; i++) {
            businessList.push({ key: res.data[i].id, value: res.data[i].business_name, campus_id: res.data[i].campus_id })
            if (i == 0) {
              //  获取套餐
              this.getPacketData(res.data[0].campus_id)
            }
          }
          for (var i = 0; i < this.addList.length; i++) {
            if (this.addList[i].key === 'business_id') {
              this.addList[i].option = businessList
              this.addList[i].model = businessList[0].key
            }
            if (this.addList[i].key === 'campus_id') {
              this.addList[i].model = businessList[0].campus_id
            }
          }
          this.assignment(this.addList, res.data[0])
        } else {
          this.assignment(this.addList, res.data[0])
        }
      }
    }

    async getPacketData(id) {
      const res: any = await CourseModule.getPacketData({ campus_id: id })
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].key === 'packet_id') {
          this.addList[i].option = res.data
        }
      }
    }
    newOrder(){
      if(this.pageName === 'edu-order-page') {
        const customer_id = this.$route.query.customer_id
        const business_id = this.$route.query.business_id
        this.isEduOrderPage = true
        this.getOtherData('', customer_id)
        this.getOtherData(business_id, '')
        this.getPacketData(business_id)
      }
      
    }
    closeLoges(){
      this.is_show_log = false
      this.actionBoolean = false
      this.w_default = '50%'
    }
    addSuccessPop(val) {
      if(val.type === 'true') {
        for(var j=0;j<this.addList.length;j++) {
          if(this.addList[j].key === 'customer_id') {
            this.addList[j].option.push({key: val.customer_id, value: val.customer_name})
            this.addList[j].model = val.customer_id
            this.isEduOrderPage = true
            this.getCustomerInfo(val.customer_id)
          }
        }
      }
      this.dialogAddPop = false
    }


     // 创建客户
    createCustomer() {
      this.getCustomrListPop()
    }
    async optionPop() {
      const res: any = await CourseModule.options({ optionId: this.optionIdPop, org_id: this.org_id })
      if (res.code === 200) {
        this.optionListPop = res.data
        this.dialogAddPop = true
      }
    }
    async getCustomrListPop() {
      const res: any = await CourseModule.customerPage({ org_id: this.org_id })
      if (res.code === 200) {
        let header = res.data.page_section[0].entity.entity_fields
        for (var i = 0; i < header.length; i++) {
          const existsType: string = header[i].exists_type
          if (existsType.indexOf('modify') >= 0) {
            this.modifyHeaderPop.push(header[i])
          }
        }
        this.optionIdPop = res.data.page_section[0].entity.id
        this.pageNamePop = res.data.key
        this.allDataPop = res.data

        this.optionPop()
      }
    }


    getHeight() {
      window.onresize = () => {
        this.p_hight = window.innerHeight - 80 + 'px'
      }
    }
    @Watch('dialogAdd')
    isShow(val) {
      this.getHeight()
      this.essentialList()
      this.newOrder()
      if (val) {
        if (this.pageName === 'edu-business-page') {
          if(this.isAddType === 'edit') {
            this.actionBoolean = true
            this.orderId = this.itemValue.id
            this.logesFrom = 'edu_business'
            this.w_default = '80%'
            this.is_show_log = true
          } else {
            this.actionBoolean = false
            this.w_default = '50%'
            this.is_show_log = false
          }
        }
      
        this.addList = []
        for (var i = 0; i < this.modifyHeader.length; i++) {
          const table_name = this.modifyHeader[i].table_name ? this.modifyHeader[i].table_name : ''
          if (this.modifyHeader[i].data_type === 'string') {
            if (this.modifyHeader[i].key === 'other_name') {
              this.addList.push({ show: false, name: this.modifyHeader[i].name, model: '', key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            }
          } else if (this.modifyHeader[i].data_type === 'dict') {
            if (this.modifyHeader[i].key === 'order_type' && this.pageName === 'edu-order-page') {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 1, option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else if (this.pageName === 'edu-base-course-page' && this.modifyHeader[i].key === 'class_minutes') {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 60, option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else if (this.pageName === 'edu-business-page' && this.modifyHeader[i].key === 'business_status') {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '2', option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else if (this.pageName === 'edu-customer-page'){
              if(this.modifyHeader[i].key === 'status') {
                for(var j = 0;j < this.modifyHeader[i].dict_list.length; j++) {
                  this.modifyHeader[i].dict_list[j].key = Number(this.modifyHeader[i].dict_list[j].key)
                }
                this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 1, option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
              } else if (this.modifyHeader[i].key === 'intention') {
                this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 2, option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
              } else {
                this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
              }
            } else {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            }
          } else if (this.modifyHeader[i].data_type === 'key_value' || this.modifyHeader[i].data_type === 'foreign-key') {
            if (this.modifyHeader[i].foreign_type === 'many-to-many') {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: [], type: 'array', option: this.optionList[this.modifyHeader[i].key], key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type, foreign_type: this.modifyHeader[i].foreign_type })
            } else {
              let optionArr = []
              for (var k = 0; k < this.optionList[this.modifyHeader[i].key].length; k++) {
                if (this.optionList[this.modifyHeader[i].key][k].is_enabled === 1) {
                  optionArr.push(this.optionList[this.modifyHeader[i].key][k])
                } else if (this.optionList[this.modifyHeader[i].key][k].is_enabled === 0) {

                } else {
                  optionArr.push(this.optionList[this.modifyHeader[i].key][k])
                }
              }

              if(this.modifyHeader[i].key === 'employee_id') {
                this.addList.push({ show: false, name: this.modifyHeader[i].name, model: '', type: 'string', option: optionArr, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type, foreign_type: this.modifyHeader[i].foreign_type })
              } else {
                this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', type: 'string', option: optionArr, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type, foreign_type: this.modifyHeader[i].foreign_type })
              }
            }
          } else if (this.modifyHeader[i].data_type === 'boolean') {
            if (this.modifyHeader[i].key === 'is_hour_limit' && this.pageName === 'edu-packet-page') {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 1, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else if ((this.modifyHeader[i].key === 'is_other' && this.pageName === 'edu-base-course-page') || (this.modifyHeader[i].key === 'is_formal' && this.pageName === 'edu-base-course-page')) {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 1, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            }
          } else if (this.modifyHeader[i].data_type === 'number') {
            this.addList.push({ show: true, name: this.modifyHeader[i].name, model: undefined, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
          } else if (this.modifyHeader[i].data_type === 'datetime') {
            this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
          } else if (this.modifyHeader[i].data_type === 'global-component') {
            this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
          } else if (this.modifyHeader[i].data_type === 'rich_text') {
            this.addList.push({ show: true, name: this.modifyHeader[i].name, model: `<p></p>`, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
          }
        }
        
        if (this.isAddType === 'edit') {
          this.is_show_80 = false
          this.getChange(this.itemValue.is_hour_limit, 'class_hours')
          this.assignment(this.addList, this.itemValue)
          const imgList = this.addList.map((item) => {
            if (this.pageName === 'edu-banner-page') {
              if (item.key === 'image_url') {
                this.fileList = [{
                  url: item.model
                }]
                return 1
              }
            } else {
              return 0
            }
          })
        }
        if (this.pageName === 'edu-employee-page') {
          for (var i = 0; i < this.addList.length; i++) {
            if (this.addList[i].key === 'is_teacher') {
              this.changeTeacher(this.addList[i].model)
            }
          }
        }else if (this.pageName === 'edu-business-page') {
          if (Number(this.itemValue.business_type) === 2) {  // 非试听
            this.getChange(false, 'teacher_id')
          } else if(Number(this.itemValue.business_type) === 1) {  // 试听
            this.getChange(true, 'teacher_id')
          }
        }
      }
    }

    assignment(one, two) {
      for (var i = 0; i < one.length; i++) {
        for (var j in two) {
          if (one[i].key === j) {
            if (one[i].data_type === 'dict') {
              let flag = false
              for (var k = 0; k < one[i].option.length; k++) {
                if(Number(one[i].option[k].key) === Number(two[j])) {
                  flag = true
                }
                one[i].option[k].key = Number(one[i].option[k].key)
              }
              if(flag) {
                one[i].model = Number(two[j])
              } else {
                one[i].model = ''
              }        
            } else if (one[i].data_type === 'datetime') {
              one[i].model = new Date(two[j] * 1000)
            } else if (one[i].data_type === 'key_value' || one[i].data_type === 'foreign-key') {

              
              if (one[i].type === 'string') {
                if (this.isEduOrderPage) {
                  one[i].model = two[j]
                } else {
                  one[i].model = two[j].key
                }
              } else if (one[i].type === 'array') {
                if(this.pageName === 'edu-subject-page' && one[i].key === 'essential') {
                  one[i].model = JSON.parse(two['essential_content'])
                } else {
                  one[i].model = two[j]
                } 
              }
            } else {
              one[i].model = two[j]
            }
          }
        }
      }
    }

    // 添加占用弹窗关闭
    close() {
      this.$emit('get-business-details', false)
      this.closeLoges()
    }
    // 添加占用弹窗确定
    add() {
      let data = {
        data: {}
      }
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].data_type === 'datetime') {
          data.data[this.addList[i].key] = Date.parse(this.addList[i].model) / 1000
        } else {
          data.data[this.addList[i].key] = this.addList[i].model
        }
      }
      data['data_id'] = this.itemValue.id
      this.editData(data)
    }

    async editData(data) {
       if(this.pageName === 'edu-subject-page') {
         data.data['essential_content'] = JSON.stringify(data.data.essential)
        if(data.data.essential.length > 0) {
          let arr = []
          for(var i = 0;i< data.data.essential.length-1;i++) {
              var ar = data.data.essential[i].concat(data.data.essential[i+1])
              for(var j=0;j<ar.length;j++){
                  arr.push(ar[j])
              }
          }
          let newArr = Array.from(new Set(arr))
          data.data.essential = newArr
        }
      }
      const res: any = await CourseModule.editItem({ data: data, optionId: this.optionId })
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '编辑成功!'
        })
        this.$emit('get-business-details', true)
      } else {
        this.$message.error('编辑失败！')
      }
      this.closeLoges()
    }

    async addData(data) {
      if(this.pageName === 'edu-subject-page') {
        data.data['essential_content'] = JSON.stringify(data.data.essential)
        if(data.data.essential.length > 0) {
          let arr = []
          for(var i = 0;i< data.data.essential.length-1;i++) {
              var ar = data.data.essential[i].concat(data.data.essential[i+1])
              for(var j=0;j<ar.length;j++){
                  arr.push(ar[j])
              }
          }
          let newArr = Array.from(new Set(arr))
          data.data.essential = newArr
        }
      }
      if (this.pageName === 'edu-order-page') {
        const res: any = await CourseModule.addItemOrder({ data: data })
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          this.$emit('get-business-details', true)
        } else {
          this.$message.error('添加失败！')
        }
      } else if (this.pageName === 'edu-customer-page') {
        const res: any = await CourseModule.addItemCustomer({ data: data })
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          this.$emit('get-business-details', {type: 'true', customer_name: res.data.customer_name})
        } else {
          this.$message.error('添加失败！')
        }
      } else {
        if (this.pageName === 'edu-business-page') {
          data.data.name = this.addCustomer_name
          data.data.phone = this.addCustomer_phone
        }

        const res: any = await CourseModule.addItem({ data: data, optionId: this.optionId })
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          if(this.pageName === 'edu-business-page') {
            if(res.data && res.data.customer_name) {
              this.$emit('get-business-details', {type: 'true', customer_name: res.data.customer_name})
            } else {
              this.$emit('get-business-details', {type: 'true'})
            }
          } else {
            this.$emit('get-business-details', {type: 'true'})
          }
          
        } else {
          this.$message.error('添加失败！')
        }
      }
    }

    getChange(val, type) {
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].key === type) {
          if (val) {
            this.addList[i].show = true
          } else {
            this.addList[i].show = false
          }
        }
      }
    }
    changeTeacher(val) {
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].key === 'expect_release_hour' || this.addList[i].key === 'instrument_type_id' || this.addList[i].key === 'teacher_profile' || this.addList[i].key === 'teacher_level') {
          if (!val) {
            this.addList[i].show = false
          } else {
            this.addList[i].show = true
          }
        }
      }
    }

    // 监听是否限制课时控制总课时
    activeChange(val, item) {
      if (this.pageName === 'edu-packet-page' && item.key === 'is_hour_limit') {
        this.getChange(val, 'class_hours')
      } else if (this.pageName === 'edu-employee-page' && item.key === 'is_teacher') {
        this.changeTeacher(val)
      }
    }

    handleRemove(file, fileList) {
      console.log(file, fileList)
    }
    handlePreview(file) {
      console.log(file)
    }
    onBeforeUp(file) {}
    onSuccessUp(res, file) {
      this.addList.forEach(element => {
        if (element.key === 'image_url') {
          element.model = 'https://' + res[0]
        }
      })
    }
    mounted() {}
}
